import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import {useDispatch, useSelector} from "react-redux";
import CMMCLineItemsSection from "./CMMCLineItemsSection";
import BBIconChecklistSecurityLock from "../../../../../assets/bbCustomIcons/BBIconChecklistSecurityLock";
import BBIconCertifiedAttestation from "../../../../../assets/bbCustomIcons/BBIconCertifiedAttestation";
import CMMCReportsSectionComingSoon from "./CMMCReportsSectionComingSoon";
import {boardChangeActiveCMMCModuleTab} from "../../../../../actions";
// import {BBTourCMMCModule} from "./BBTourCMMC";

import ModuleNotAvailableModal from "../../../../../components/customBreachBits/modals/ModuleNotAvailableModal";

function TabContainer({children, dir}) {
    return (
        <div dir={dir} style={{padding: 8 * 3}}>
            {children}
        </div>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
    dir: PropTypes.string.isRequired,
};

const TabHolder = (props) => {
    const {cmmcModuleActiveTab} = useSelector(({misc}) => misc);
    // const authUser = useSelector(({auth}) => auth.authUser);
    const dispatch = useDispatch();
    const highestTabIndex = 3;
    const {customerInView} = useSelector(({customer}) => customer);

    const tabTurn = (newValue) => dispatch(boardChangeActiveCMMCModuleTab(newValue));

    const changeActiveTab = (newValue) => {
        if (newValue > -1 && newValue <= highestTabIndex) {
            dispatch(boardChangeActiveCMMCModuleTab(newValue));
        } else {
            dispatch(boardChangeActiveCMMCModuleTab(0));
        }
    }

    const {theme} = props;

        return (
            <div className="w-100 animated fadeIn animation-duration-7">
                {!!customerInView && <ModuleNotAvailableModal moduleId={6}/>}


                {/*<BBTourCMMCModule tabTurn={tabTurn}/>*/}
                <AppBar position="sticky" color="default">
                    <Tabs
                        value={cmmcModuleActiveTab}
                        onChange={(event, newValue) => changeActiveTab(newValue)}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="fullWidth"
                        scrollButtons="on"
                    >
                        {/*<Tab icon={<BBIconDashboardGaugeLayout/>} className="tab" label="Insights"/>*/}
                        <Tab icon={<BBIconChecklistSecurityLock/>} className="tab tourStepPracticesTab" label="Practices"/>
                        <Tab icon={<BBIconCertifiedAttestation/>} className="tab tourStepReportsTab" label="Reports"/>
                    </Tabs>
                </AppBar>
                <SwipeableViews
                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                    index={cmmcModuleActiveTab}
                    onChangeIndex={(event, newValue) => changeActiveTab(newValue)}
                >
                    {/*<TabContainer dir={theme.direction}>*/}
                    {/*    <CMMCOverviewSection customerId={customerInView} />*/}
                    {/*</TabContainer>*/}
                    <TabContainer dir={theme.direction}>
                        <CMMCLineItemsSection customerId={customerInView}/>
                    </TabContainer>
                    <TabContainer dir={theme.direction}>
                        <CMMCReportsSectionComingSoon />
                    </TabContainer>
                </SwipeableViews>
            </div>
        );

}

TabHolder.propTypes = {
    theme: PropTypes.object.isRequired,
};

export default withStyles(null, {withTheme: true})(TabHolder);